import React, { memo } from "react";
import {
  InfoWindow
} from "@react-google-maps/api";
import { SiteType } from "../../../../constants/WebMap";
import SiteTooltip from "../../../../components/elements/SiteTooltip";

const EdotcoSiteTooltipSection = ({
  edotcoSiteTooltipData,
  eyeIcons,
  selectedEdotcoSiteOperator,
  setEdotcoSiteTooltipData,
  operatorsPermittedECSiteET,
  operatorsPermittedECSitePT
}) => {
  return (
    edotcoSiteTooltipData
      ? <InfoWindow
        position={{
          lat: edotcoSiteTooltipData.latitude,
          lng: edotcoSiteTooltipData.longitude,
        }}
        onCloseClick={() => {
          setEdotcoSiteTooltipData(null);
        }}
        options={{
          disableAutoPan: true,
          pixelOffset: edotcoSiteTooltipData.siteType === SiteType.EdotcoSite ||
            edotcoSiteTooltipData.customersOnSite?.length === 1
            ? new window.google.maps.Size(0, -20)
            : new window.google.maps.Size(10, -20),
        }}
      >
        <div>
          {eyeIcons.sites && (
            <SiteTooltip
              selectedOperator={selectedEdotcoSiteOperator?.operatorList}
              type={edotcoSiteTooltipData?.siteType ? edotcoSiteTooltipData.siteType  : SiteType.EdotcoSite}
              data={edotcoSiteTooltipData}
              operatorsPermittedECSiteET={operatorsPermittedECSiteET}
              operatorsPermittedECSitePT={operatorsPermittedECSitePT}
            />
          )}
        </div>
      </InfoWindow>
      : <></>
  )
};

export default memo(EdotcoSiteTooltipSection);